
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { WxPushSettingService, StudentStaticTimeIntervalDto, StudentStaticTimeIntervalItem } from "@/api/service-proxies";
import DayOfWeek from '../dayOfWeek'
@Component({
    name: "PriVewDialog",
})
export default class extends Vue {
    dialogTableVisible = false;
    sumiting = false
    isPushToMaster = false
    wxPushSettingService = new WxPushSettingService
    studentStaticTimeIntervalDto = new StudentStaticTimeIntervalDto({
        isOpenPushMasterWithStudentStatic: false,
        studentStaticTimeIntervalItem: []
    })
    private readonly daysOfWeek = DayOfWeek
    public open(id) {
        this.wxPushSettingService.getPushMasterStudentStaticTimeInterval(id)
            .then((res) => {
                this.studentStaticTimeIntervalDto = res
                if (this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem == null || this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem == undefined) {
                    this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem = []
                    // this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem.push(new StudentStaticTimeIntervalItem({
                    //     startTime: '10:00:00',
                    //     startDayOfWeek: 1
                    // }))
                }
                // 使用类型断言
                // this.studentStaticTimeIntervalDto = { ...this.studentStaticTimeIntervalDto } as StudentStaticTimeIntervalDto;
                this.dialogTableVisible = true;
            })
            .catch((res) => {
                this.$message.error('请求数据失败')
            })
    }
    private handleAddAccessTimeInterval() {
        let week = this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem.length >= 6 ? 0 : this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem.length + 1
        const newItem = new StudentStaticTimeIntervalItem({
            startTime: '10:00:00', // 确保格式正确
            startDayOfWeek: week
        });

        this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem = [
            ...this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem,
            newItem
        ];
        // 使用类型断言
        this.studentStaticTimeIntervalDto = { ...this.studentStaticTimeIntervalDto } as StudentStaticTimeIntervalDto;

    }
    handleRemoveAccessTimeInterval(item, index) {
        this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem.splice(index, 1)
        // this.$forceUpdate();
    }
    updatePushToMaster() {
        if(this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem.length==0){
             this.$message.warning('请创建推送时间');
            return;
        }
        const items = this.studentStaticTimeIntervalDto.studentStaticTimeIntervalItem;
        const uniqueItems = new Set(items.map(item => `${item.startDayOfWeek}-${item.startTime}`));

        if (uniqueItems.size !== items.length) {
            this.$message.warning('存在重复的星期和时间段组合');
            return;
        }

        this.wxPushSettingService.updatePushMasterStudentStaticTimeInterval(this.studentStaticTimeIntervalDto)
            .then((res) => {
                this.dialogTableVisible = false;
                this.$message.success('设置成功')
            })
            .catch((res) => {
                this.$message.error('设置失败')
            })
    }
    hideModal() {
        this.dialogTableVisible = false;
    }
}
